import Utilities from '../utilities/utilities';
import * as deepmerge from 'deepmerge';
import { gsap } from 'gsap';

export default class Countdown {
	/**
	 * @param {string} element - Selector
	 * @param {Object} options - User options
	 */
	constructor(element, options) {
		this.element = element || '.js-countdown';
		this.defaults = {
			triggers: this.element,
		};
		this.options = options ? deepmerge(this.defaults, options) : this.defaults;

		window.addEventListener('DOMContentLoaded', () => {
			this.init();
			this.initEvents(this.options.triggers);
		});
	}

	/**
	 * Init
	 */
	init() {
		this.DOM = {
			element: document.querySelectorAll(this.element),
		};
	}

	/**
	 * Initialize events
	 * @param {string} triggers - Selectors
	 */
	initEvents(triggers) {

        gsap.utils.toArray(triggers).forEach((element) => {
			this.myAnimation(element);
		});
	}


	/**
	 * my Animation
	*/
	myAnimation(item) {
	
		if(item) {
	
			const daysEl = item.querySelector(".js-countdown-days");
			const hoursEl = item.querySelector(".js-countdown-hours");
			const minsEl = item.querySelector(".js-countdown-mins");
			const secondsEl = item.querySelector(".js-countdown-seconds");
			const Brithdays = item.dataset.countdown;

			// Set the date we're counting down to
			var countDownDate = new Date(Brithdays).getTime();

			// Update the count down every 1 second
			var x = setInterval(function() {

			// Get todays date and time
			var now = new Date().getTime();

			// Find the distance between now and the count down date
			var distance = countDownDate - now;

			// Time calculations for days, hours, minutes and seconds
			var days = Math.floor(distance / (1000 * 60 * 60 * 24));
			var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
			var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
			var seconds = Math.floor((distance % (1000 * 60)) / 1000);
			
			daysEl.innerHTML = days;
			hoursEl.innerHTML = hours;
			minsEl.innerHTML = minutes;
			secondsEl.innerHTML = seconds;

			// If the count down is finished, write some text 
			if (distance < 0) {
				clearInterval(x);
				item.remove();
			}
			}, 1000);

	}

	}
}
